import React from 'react';
import './nav.css'

const Nav = (props) => {
    return ( 
        <nav>
            {props.children}
        </nav>
     );
}
 
export default Nav;